// const baseURL = 'http://localhost:3001'

const baseURL = 'https://whirlpool.diacto.com'


export {baseURL}